module.exports = __webpack_public_path__ + "static/landing-background-bw-ba61cde98a3ba32945b3f5ac7f1554fd.jpg";